<template>
  <v-expansion-panel>
    <v-expansion-panel-title v-slot="{ expanded }">
      <v-row no-gutters>
        <v-col cols="4" class="text-primary ">
          Fiche Signalement / Visite Preinstallation
        </v-col>
        <v-col cols="8" class="text-medium-emphasis">
          <v-fade-transition leave-absolute>
            <span v-if="expanded" key="edit"> Editer la fiche puis sauvegarder </span>
            <div v-else key="summary">
              <div v-if="ficheSignalement.account">
                {{ ficheSignalement.account.name }}
              </div>
              <div v-if="ficheSignalement.laverie">
                / {{ ficheSignalement.laverie.name }}
              </div>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="ficheSignalement.type" :items="signalementTypes" label="Type"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le type de la fiche
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.type" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="ficheSignalement.account" :items="accounts" item-title="name" return-object label="Siège"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="ficheSignalement.laverie" :items="laveries" item-title="name" return-object
            label="Laverie"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <template v-if="ficheSignalement.laverie && ficheSignalement.laverie.address">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pr-1">
            <v-text-field name="numero" hint="Le numéro dans la rue" v-model="ficheSignalement.laverie.address.numero"
               label="Numero">
            </v-text-field>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-text-field name="rue" hint="Le nom de la rue" v-model="ficheSignalement.laverie.address.rue"
               label="Rue">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Changez l'adresse si nécessaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pr-1">
            <v-text-field name="codepostale" hint="Le code postale de la ville"
              v-model="ficheSignalement.laverie.address.codepostale"  label="Code Postale">
            </v-text-field>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-text-field name="ville" hint="Le nom de la ville" v-model="ficheSignalement.laverie.address.ville"
               label="Ville">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
      </template>
      <v-row v-if="ficheSignalement.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field v-model="ficheSignalement.visitDate" type="date">
            <template #label>
              Date de visite<span class="text-red"><strong> *</strong></span>
            </template>
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de la visite
        </v-col>
      </v-row>
      <template v-if="ficheSignalement.visitDate">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="2" class="pr-1">
            <v-text-field name="etage" v-model="ficheSignalement.accessibility.etage" 
              label="Etage">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-text-field name="ascenseur" v-model="ficheSignalement.accessibility.ascenseur"
               label="Ascenseur">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pl-1">
            <v-text-field name="escalier" v-model="ficheSignalement.accessibility.escalier" 
              label="Escalier">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Détaillez l'accessibilité
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="2" class="pr-1">
            <v-text-field name="codePorte" v-model="ficheSignalement.accessibility.codePorte"
               label="Code Porte">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-text-field name="parkingPrive" v-model="ficheSignalement.accessibility.parking"
               label="Parking Privé">
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pl-1">
            <v-text-field name="cle" v-model="ficheSignalement.accessibility.key" 
              label="Clé">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
      </template>
      <v-row v-if="
        ficheSignalement.visitDate &&
        ficheSignalement.type == signalementTypeSignalementTechnicien
      " no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field name="motifSignalement" v-model="ficheSignalement.motifSignalement" 
            label="Motif Signalement">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Précisez le motif de signalement
        </v-col>
      </v-row>
      <v-row v-if="ficheSignalement.visitDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="ficheSignalement.visitedBy" :items="users" item-title="fullName" return-object
            label="Visite faite par"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le technicien
        </v-col>
      </v-row>
      <template v-if="ficheSignalement.visitedBy">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3" class="pr-1">
          <v-text-field name="responsableSiteNom" hint="Nom du responsable site"
            v-model="ficheSignalement.manager.lastname"  label="Nom">
          </v-text-field>
        </v-col>
        <v-col cols="3" class="pl-1">
          <v-text-field name="responsableSitePrenom" hint="Prénom du responsable site"
            v-model="ficheSignalement.manager.name"  label="Prénom">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez le responsable site
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3" class="pr-1">
          <v-text-field name="responsableSiteMobile" hint="Mobile du responsable site"
            v-model="ficheSignalement.manager.mobile"  label="Mobile">
          </v-text-field>
        </v-col>
        <v-col cols="3" class="pl-1">
          <v-text-field name="responsableSiteTel" hint="Téléphone du responsable site"
            v-model="ficheSignalement.manager.telephone"  label="Téléphone">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field name="responsableSiteEmail" hint="Courriel du responsable site"
            v-model="ficheSignalement.manager.email"  label="Courriel">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3" class="pr-1">
          <v-text-field name="contactTechNom" hint="Nom du contact technique"
            v-model="ficheSignalement.techUser.lastname"  label="Nom">
          </v-text-field>
        </v-col>
        <v-col cols="3" class="pl-1">
          <v-text-field name="contactTechPrenom" hint="Prénom du contact technique"
            v-model="ficheSignalement.techUser.firstname"  label="Prénom">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez le contact technique
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3" class="pr-1">
          <v-text-field name="contactTechMobile" hint="Mobile du contact technique"
            v-model="ficheSignalement.techUser.mobile"  label="Mobile">
          </v-text-field>
        </v-col>
        <v-col cols="3" class="pl-1">
          <v-text-field name="contactTechTel" hint="Téléphone du contact technique"
            v-model="ficheSignalement.techUser.telephone"  label="Téléphone">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field name="contactTechEmail" hint="Courriel du contact technique"
            v-model="ficheSignalement.techUser.email"  label="Courriel">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn :filePath="ficheSignalementTemplatePath" :fileName="ficheSignalementFileName"
          :dataSet="ficheSignalementGen">Save</generate-doc-btn>
      </v-card-actions>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { User } from "@/types";
import type { FicheSignalement } from "@/types";
import { SignalementType } from "@/types";
import { flattenFicheSignalement } from "@/types";
import type { Accessibility } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import { watch } from "vue";

interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

const ficheSignalement = ref<FicheSignalement>({
  manager: {} as User,
  techUser: {} as User,
  accessibility: {} as Accessibility,
} as FicheSignalement);
const laveries = ref<Laverie[]>([]);

const ficheSignalementGen = computed(() =>
  flattenFicheSignalement(ficheSignalement.value)
);
const signalementTypeSignalementTechnicien = SignalementType.Signalement_Technicien;
const signalementTypes = Object.values(SignalementType);

const ficheSignalementTemplatePath = "templates/FicheDeSignalementTemplate.docx";

const ficheSignalementFileName = computed(() => {
  if (ficheSignalement.value.laverie?.name) {
    return `FicheDeSignalement_${ficheSignalement.value.laverie.name}`;
  }
  return "FicheDeSignalement";
});

watch(
  () => ficheSignalement.value.account,
  async (selectedAccount) => {
    if (!selectedAccount) return;

    // Reset selected laverie
    ficheSignalement.value.laverie = null;
    laveries.value = [];

    await fetchLaveries(selectedAccount.id);
  }
);

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onCancel = () => {
  // Clear form
  ficheSignalement.value = {
    manager: {} as User,
    techUser: {} as User,
    accessibility: {} as Accessibility,
  } as FicheSignalement;
  laveries.value = [];
};
</script>
